import { create } from 'zustand';

/**
 * Generic store for managing header button state in settings screens.
 * This can be reused by any settings screen that needs a primary action button
 * in the SettingsLayout header (e.g., Done, Save, Submit, etc.)
 */
interface SettingsHeaderState {
  isSaving: boolean;
  isDisabled: boolean;
  handleSave: (() => Promise<void>) | null;
  setHandleSave: (handler: (() => Promise<void>) | null) => void;
  setIsSaving: (isSaving: boolean) => void;
  setIsDisabled: (isDisabled: boolean) => void;
}

export const useSettingsHeaderStore = create<SettingsHeaderState>((set) => ({
  isSaving: false,
  isDisabled: false,
  handleSave: null,
  setHandleSave: (handler) => set({ handleSave: handler }),
  setIsSaving: (isSaving) => set({ isSaving }),
  setIsDisabled: (isDisabled) => set({ isDisabled }),
}));
